module.exports = __webpack_public_path__ + "img/sharelogo.8ba9a4d3.png";